import preload from './preload.js'
import { gsap, TimelineMax } from "gsap";
import { BREAKPOINTS } from '../constants.js'
import * as viewport from '../Utils/viewport.js'
import { CSSRulePlugin } from "gsap/CSSRulePlugin";

gsap.registerPlugin(CSSRulePlugin);

export default function () {

    //if not on the landing page, then return
    let JibberJabberLanding = document.getElementsByClassName('Hero--animated')
    if (!JibberJabberLanding.length) return

    let preloadContainer = document.getElementsByClassName('Preload--container')

    preload(preloadContainer, function () {
        preloadContainer[0].classList.add('is-ready');
        JJanimation()
    })

    function JJanimation(){
        let JibberJabber = new TimelineMax()

        let Jibber = '.Hero-left'
        let Jabber = '.Hero-right'
        let FG = '.Hero-fg';
        let BG = '.Hero-bg';

        JibberJabber.set(Jibber, { "left": "22%", y: "90%", opacity: 0, rotation: 0 })
        JibberJabber.set(Jabber, { "left": "70%", y: "90%", opacity: 0, rotation: 0 })
        JibberJabber.set(FG, { opacity: 0, scale: 1.2 })
        JibberJabber.set(BG, { opacity: 0, scale: 1.2 })

        JibberJabber.to(FG, 1, { opacity: 1, scale: 1 })
        JibberJabber.to(BG, 1, { opacity: 1, scale: 1 }, '-=1')

        JibberJabber.to(Jibber, 1, { "left": "36%", y: "10%", opacity: 1, rotation: 17, ease: "back(.7)" })
        JibberJabber.to(Jabber, 1, { "left": "58%", y: "10%", opacity: 1, rotation: -9, ease: "back(.7)" }, '-=.55')

        window.addEventListener('scroll', jibjab);

        let deviceOffset = viewport.isMobile() ? 69 : 110;

        function jibjab() {
            let topScroll = window.scrollY;
            let container = preloadContainer[0].getBoundingClientRect()
            let containerHeight = preloadContainer[0].getBoundingClientRect().height
            let containerTop = container.top
            let containerTopWhole = containerTop - deviceOffset

            if ((containerTopWhole <= 0) && (container.bottom) > 0) {
                let reverse = -Math.abs(container.top - deviceOffset) * -1

                JibberJabber.to(Jibber, 0, { y: reverse })
                JibberJabber.to(Jabber, 0, { y: reverse })
            } else if (containerTopWhole > 0) {
                JibberJabber.to(Jibber, 0, { y: 0 })
                JibberJabber.to(Jabber, 0, { y: 0 })
            }
        }
    }
}